module.exports = __webpack_public_path__ + "media/packs/images/flags/AM-b025f47fbd1d6a1dea864e0f0771fa78.png";